<template>
  <div class="analytics">
    <div class="fans-stats">
      <div class="fans-stat">
        <h1 class="fans-stat__number">{{fansSize}}</h1>
        <aside class="fans-stat__label">
          Fans
        </aside>
      </div>
      <div class="fans-stat">
        <h1 class="fans-stat__number">{{paidFansSize}}</h1>
        <aside class="fans-stat__label">
          Paid
        </aside>
      </div>
      <div class="fans-stat">
        <h1 class="fans-stat__number">${{(monthlyRevenue * 12).toFixed(2)}}</h1>
        <aside class="fans-stat__label">
          Yearly Revenue
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'analytics',
  props: {
  },
  components: {
  },
  data () {
    return {
      userData: null
    }
  },
  methods: {
  },
  created () {
  },
  computed: {
    ...mapState(['channel']),
    fans () {
      return this.channel.fans
    },
    fansSize () {
      return _.size(this.channel.fans)
    },
    paidFansSize () {
      let paidFans = []
      _.each(this.channel.fans, (fan) => {
        if (!fan.tier) return
        if (fan.tier !== 'free') {
          paidFans.push(fan)
        }
      })
      return paidFans.length
    },
    monthlyRevenue () {
      if (!this.channel.tiers || !this.channel.tiers.paid) return
      return this.channel.tiers.paid.price * this.paidFansSize
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .analytics {
    padding: $unit-3 0;
    margin-bottom: $unit-3;
  }

  .analytics-heading {
    @include caps;
    padding: $unit-3 0;
  }

  .fans-stats {
    display: flex;
    padding-top: $unit-3;
  }

  .fans-stat {
    flex-basis: 33.333%;

    &__number {
      font-size: $fontSize-xl;
      font-weight: 200;
      text-align: left;
    }

    &__label {
      @include caps;
      text-align: left;
      margin-top: $unit-2;
    }

  }

</style>
